import { ofType } from 'vue-tsx-support';

import LazyHydrateSsr from './LazyHydrateSsr.vue';

const lazyHydrateSsrTs = ofType().convert(LazyHydrateSsr);

export { lazyHydrateSsrTs as LazyHydrateSsr };
